<template>
  <div id="app">
    <div class="app-actions" v-if="showInstallButton">
      <button class="" @click="installApp">Instalează Aplicația</button>
      <button @click="openApp">Mergi la aplicație</button>
    </div>

    <!-- Conținut aplicație -->
    <div v-if="!showInstallButton && !isStandalone">
      <router-view />
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      deferredPrompt: null, // Evenimentul `beforeinstallprompt`
      showInstallButton: false, // Control pentru afișarea butonului de instalare
      isStandalone: false, // Detectează dacă aplicația rulează în mod instalat (fullscreen)
    };
  },
  mounted() {
    // Ascultă evenimentul `beforeinstallprompt` pentru instalare
    window.addEventListener("beforeinstallprompt", (e) => {
      e.preventDefault(); // Previne promptul implicit
      this.deferredPrompt = e; // Salvează evenimentul
      this.showInstallButton = true; // Afișează butonul de instalare
    });

    window.addEventListener("appinstalled", this.handleAppInstalled);

    // Detectează dacă aplicația rulează în modul instalat (fullscreen/standalone)
    this.isStandalone =
      window.matchMedia("(display-mode: standalone)").matches ||
      window.navigator.standalone; // Pentru iOS
  },
  methods: {
    async installApp() {
      if (this.deferredPrompt) {
        this.deferredPrompt.prompt(); // Afișează promptul de instalare
        const choiceResult = await this.deferredPrompt.userChoice;

        if (choiceResult.outcome === "accepted") {
          console.log("Utilizatorul a acceptat instalarea.");
          this.showInstallButton = false; // Ascunde butonul după instalare
        } else {
          console.log("Utilizatorul a refuzat instalarea.");
        }

        this.deferredPrompt = null; // Resetează evenimentul
      }
    },
    openApp() {
      console.log("Aplicația rulează deja în modul instalat.");
      this.showInstallButton = false; // Ascunde butonul de instalare
    },
    handleAppInstalled() {
      console.log("Aplicația a fost instalată cu succes.");
      this.showInstallButton = false; // Ascunde butonul de instalare
      alert("Aplicația a fost instalată cu succes.");
    },
  },
};
</script>

<style>
/* Stiluri globale */
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

/* Stiluri pentru butoane */
.app-actions {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.app-actions button {
  padding: 10px 20px;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  font-size: 16px;
  margin: 10px;
}

.app-actions button:hover {
  background-color: #0056b3;
}
#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}
body {
  background-color: #daf4e3!important;
}

.loader{color:#fff;position:fixed;box-sizing:border-box;left:-9999px;top:-9999px;width:0;height:0;overflow:hidden;z-index:999999}.loader:after,.loader:before{box-sizing:border-box;display:none}.loader.is-active{background-color:rgba(0,0,0,.85);width:100%;height:100%;left:0;top:0}.loader.is-active:after,.loader.is-active:before{display:block}.loader-bar[data-text]:before{top:calc(50% - 40px);color:#fff}.loader-bar:after{content:"";position:fixed;top:50%;left:50%;width:200px;height:20px;transform:translate(-50%,-50%);background:linear-gradient(-45deg,#4183d7 25%,#52b3d9 0,#52b3d9 50%,#4183d7 0,#4183d7 75%,#52b3d9 0,#52b3d9);background-size:20px 20px;box-shadow:inset 0 10px 0 hsla(0,0%,100%,.2),0 0 0 5px rgba(0,0,0,.2);animation:moveBar 1.5s linear infinite reverse}.loader-bar[data-rounded]:after{border-radius:15px}.loader-bar[data-inverse]:after{animation-direction:normal}@keyframes moveBar{0%{background-position:0 0}to{background-position:20px 20px}}

</style>


